<template>
  <div class="h-dialogContainer">
    <form id='updateDev'>
      <div class="row h-row-inputBox">
        <!-- 设备类型 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
            <ejs-dropdownlist name="devType" :placeholder="devTypePlaceholder" :dataSource="typeData" v-model="devinfo.typeCode" :fields="typeFields" :readonly="readDeviceType"
                              :noRecordsTemplate="noRecordsTemplate" :allowFiltering='true' :filtering='onFiltering' :filterBarPlaceholder="filterPlaceholder">
            </ejs-dropdownlist>
          </div>
        </div>
        <!-- 设备名称 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
            <input name="devName" class="e-input" :placeholder="devNamePlaceholder" type="text" v-model="devinfo.name"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
            <ejs-dropdownlist name="devSoftVersion" :placeholder="devSoftVersionPlaceholder" :dataSource="visionData" v-model="devinfo.softwareVersion"
                              :fields="visionFields" :readonly="readSoftware" :noRecordsTemplate="noRecordsTemplate">
            </ejs-dropdownlist>
          </div>
        </div>
      </div>
      <!-- IP和端口 -->
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Pm.ip')}}:</div>
            <input name="devIP" class="e-input" :placeholder="ipaAddr" type="text" v-model="deviceIP"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('System.port')}}:</div>
            <input name="devPort" class="e-input" :placeholder="port" type="text" v-model="devicePort"/>
          </div>
        </div>
      </div>
    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import { FormValidator } from '@syncfusion/ej2-vue-inputs';
  import { Query } from '@syncfusion/ej2-data';
  import { EventBus } from '../../../../plugins/eventBus';
  import { createNamespacedHelpers } from 'vuex';

  const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

  export default {
    name: 'UpdateSerDevice',
    components: {
      CustomDialog,
    },
    data() {
      return {
        devTypePlaceholder: this.$t('Topo.devType'), // 设备类型
        devNamePlaceholder: this.$t('Topo.devName'), // 设备名称
        devSoftVersionPlaceholder: this.$t('Topo.devSelect'), // 版本placeholder
        noRecordsTemplate: this.$t('Topo.noData'),
        readDeviceType: true, // 设备类型只读
        readSoftware: true,   // 设备版本只读
        deviceIP: '',
        devicePort: '',
        devinfo: {
          id: '',
          name: '',
          typeCode: 0,
          positionX: 225,
          positionY: 226,
          ipPortData: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
        },
        typeData: [], // 设备码和设备类型数据源
        typeFields: { value: 'typeCode', text: 'nameKey' },
        visionData: [], // 版本和显示版本数据源
        visionFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
        filterPlaceholder: this.$t('Topo.search'),  // ???
        ipaAddr: this.$t('Topo.devIp'),
        port: this.$t('Topo.devPort'),

        validationOption: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            devType: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
              maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            devSoftVersion: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devIP: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
            },
            devPort: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
              range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
            },
          }
        },
      };
    },
    mounted() {
      this.bindValidate();
    },
    computed: {
      ...mapGetters(['getTypeByCode']),
    },
    methods: {
      bindValidate() {
        this.formObj = new FormValidator('#updateDev', this.validationOption);
      },
      validate() {
        const formStatus = this.formObj.validate();
        return formStatus;
      },
      initData(devData) {
        const typeCode = devData.typeCode;
        this.queryDevType(typeCode);
        console.log('修改服务初始化');
        if (devData) {
          this.devinfo = devData;
          // IP和端口映射
          if (devData.equipmentIPList && devData.equipmentIPList.length > 0) {
            this.deviceIP = this.devinfo.equipmentIPList[0].ip;
            this.devicePort = this.devinfo.equipmentIPList[0].port;
          }
          // 版本映射
          const visionDataTemp = [];
          visionDataTemp.push({
            softwareVersion: this.devinfo.softwareVersion,
            displaySoftwareVersion: this.devinfo.displaySoftwareVersion
          });
          this.visionData = visionDataTemp;
          // 类型转换
          const typeTemp = [];
          typeTemp.push({
            typeCode: this.devinfo.typeCode,
            nameKey: this.getTypeByCode(this.devinfo.typeCode)
          });
          this.typeData = typeTemp;
        }
      },
      outputs(type) {
        if (!this.validate()) return;
        this.devinfo.equipmentIPList = [];
        this.devinfo.equipmentIPList.push({
          id: '',
          ip: this.deviceIP,
          port: this.devicePort,
          service: '',
          processCode: '',
          equipmentId: '',
        });
        this.threadIDMatch(this.devinfo.typeCode);
        const devInfo = {
          ...this.devinfo,
          typeCode: this.devinfo.typeCode.toString(),
        };
        //添加设备
        this.axios.post('/lte/ems/topo/device/modifyDev', devInfo).then(response => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            if (type === 'BS') {
              this.$emit('getDeviceListData');
            } else if (type === 'DS') {
              this.$emit('getServiceData');
            }
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.closeWindow();
        });
      },

      closeWindow() {
        this.$emit('close');
      },

      // 新建设备时去后台查设备类型
      queryDevType(typeCode) {
        const This = this;
        const params={ };
        This.$axios.get(`/lte/ems/topo/device/devType/${typeCode}`).then(response => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            This.typeData = response.data.resultVal;
          } else {
            This.typeData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      threadIDMatch(value) {
        if (value === 10001 ) {
          this.devinfo.equipmentIPList[0].service = 'epc';
        } else if (value === 10002) {
          this.devinfo.equipmentIPList[0].service = 'ims';
        } else if (value === 10003) {
          this.devinfo.equipmentIPList[0].service = 'mcs';
        } else if (value === 10004 || value === 10005 || value === 10006 || value === 10008) {
          this.devinfo.equipmentIPList[0].service = 'enodeb';
        } else if (value === 10007) {
          this.devinfo.equipmentIPList[0].service = 'bpdt';
        }
      },

      onFiltering(e){
        let query = new Query();
        query = (e.text !== '') ? query.where('nameKey', 'startswith', e.text, true) : query;
        e.updateData(this.typeData, query);
      },
    }
  };
</script>
